var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCSharp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M14.687 11.753v-7.5L8 .5 1.313 4.253v7.5L8 15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99 9.63a2.667 2.667 0 11-.182-3.594"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.813,
    d: "M10.162 6.35V9.6m1.625-3.25V9.6M9.35 7.162h3.25M9.35 8.787h3.25"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGcgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTE0LjY4NyAxMS43NTN2LTcuNUw4IC41IDEuMzEzIDQuMjUzdjcuNUw4IDE1LjV6Ii8+PHBhdGggZD0iTTcuOTkgOS42M2EyLjY2NyAyLjY2NyAwIDEgMS0uMTgyLTMuNTk0Ii8+PHBhdGggc3Ryb2tlLXdpZHRoPSIuODEzIiBkPSJNMTAuMTYyIDYuMzVWOS42TTExLjc4NyA2LjM1VjkuNk05LjM1IDcuMTYyaDMuMjVNOS4zNSA4Ljc4N2gzLjI1Ii8+PC9nPjwvc3ZnPg==";
export { SvgIconCSharp as ReactComponent };